import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingStateProps {
  label?: string;
  inline?: boolean;
  className?: string;
}

export function LoadingState({ label, inline, className }: LoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'flex flex-col items-center justify-center gap-2 text-muted-foreground',
        inline ? 'py-8' : 'min-h-[40vh]',
        className,
      )}
    >
      <Loader2 className="h-8 w-8 animate-spin" aria-hidden="true" />
      <span className={label ? 'text-sm' : 'sr-only'}>{label ?? 'Loading'}</span>
    </div>
  );
}
